<template>
  <div class="group relative flex flex-col">
    <label
      :for="name"
      class="text-xs uppercase text-gray-300"
      >{{ label }}{{ required ? '*' : '' }}</label
    >
    <input
      :id="name"
      :label="label"
      :name="name"
      :type="type"
      :required="required"
      :placeholder="placeholder"
      :value="value"
      class="mt-1.5 h-14 rounded-full border-2 border-gray-200 bg-white px-6 py-3 text-gray-500"
      :class="error ? 'border-red-400' : ''"
      @input="onChange" />

    <span class="absolute bottom-0 -mb-5 text-xs text-red-400">{{ error }}</span>
  </div>
</template>

<script setup lang="ts">
  type inputProps = {
    label: string
    type: string
    name: string
    value: string
    placeholder: string
    required?: boolean
    error?: string
  }
  defineProps<inputProps>()

  const emit = defineEmits<{
    (event: 'update:modelValue', payload: string): void
  }>()

  const onChange = (e: Event) => {
    emit('update:modelValue', (e.target as HTMLInputElement).value)
  }
</script>

<style>
  input::placeholder {
    @apply text-gray-250;
  }
</style>
